module.exports = __webpack_public_path__ + "static/travels-with-charley-in-search-of-america-b5846db88ca14d78d20ed53478e72fea.jpg";